import { EVENTS, publish } from 'util.pubsub';

class SubscriptionWidget extends HTMLElement {
  constructor() {
    super();
    this.planSelect = this.querySelector('[data-selling-plan-select]');
    this.cadenceSelects = this.querySelectorAll('[data-cadence-select]');
    this.sellingPlanGroups = JSON.parse(this.querySelector('[data-selling-plan-groups]').textContent);
    this.setupEventListeners();
  }

  get sectionId() {
    return this.getAttribute('section-id');
  }
  get productId() {
    return this.getAttribute('product-id');
  }
  get cadence() {
    return this.getAttribute('cadence');
  }
  set cadence(cadence) {
    this.setAttribute('cadence', cadence);
  }

  setupEventListeners() {
    this.planSelect.addEventListener('change', this.planChange.bind(this));
    this.cadenceSelects.forEach((cadenceSelect) => {
      cadenceSelect.addEventListener('change', this.cadenceChange.bind(this));
    });
  }

  cadenceChange(event) {
    this.cadence = event.target.value;
    this.planChange();
  }

  planChange() {
    publish(EVENTS.planChange, {
      detail: {
        sectionId: this.sectionId,
        productId: this.productId,
        planId: this.planSelect.value,
        cadence: this.cadence
      }
    });
  }
}

if (!customElements.get('subscription-widget')) {
  customElements.define('subscription-widget', SubscriptionWidget);
}
